import Swiper, { Navigation, Pagination } from 'swiper';

export default class Team {
    constructor(query) {
        const el = document.querySelector(query);
        if (!el) return;

        this.el = el;
        this.init();
    }

    init() {
        const slider = this.el.querySelector('#persons-slider');
        if (!slider) return;

        const btnNext = this.el.querySelector('.team__btn-next');
        const btnPrev = this.el.querySelector('.team__btn-prev');

        let isDesktop = window.innerWidth > 768;
        let desktopSwiper = null;
        let mobileSwiper = null;

        const updateButtons = () => {
            if (!btnPrev || !btnNext) return;
            const swiper = desktopSwiper || mobileSwiper;
            if (!swiper) return;

            if (swiper.slides.length <= 1 || swiper.isLocked) {
                btnPrev.classList.remove('disabled');
                btnNext.classList.remove('disabled');
                return;
            }

            if (swiper.isBeginning) btnPrev.classList.add('disabled');
            else btnPrev.classList.remove('disabled');

            if (swiper.isEnd) btnNext.classList.add('disabled');
            else btnNext.classList.remove('disabled');
        };

        const desktopSlider = () => {
            if (!isDesktop) return;

            const wrapper = slider.querySelector('.swiper-wrapper');
            const slides = Array.from(wrapper.querySelectorAll('.swiper-slide'));

            let activeIndex = 2;
            const slideWidth = slides[0].offsetWidth + 20;

            const updatePosition = () => {
                wrapper.style.transition = 'transform 0.5s ease';
                wrapper.style.transform = `translateX(calc(50% - ${(activeIndex + 0.5) * slideWidth}px))`;

                if (btnPrev) {
                    if (activeIndex === 0) btnPrev.classList.add('disabled');
                    else btnPrev.classList.remove('disabled');
                }
                if (btnNext) {
                    if (activeIndex === slides.length - 1) btnNext.classList.add('disabled');
                    else btnNext.classList.remove('disabled');
                }
            };

            updatePosition();

            if (btnNext) {
                btnNext.addEventListener('click', () => {
                    if (activeIndex < slides.length - 1) {
                        activeIndex++;
                        updatePosition();
                    }
                });
            }

            if (btnPrev) {
                btnPrev.addEventListener('click', () => {
                    if (activeIndex > 0) {
                        activeIndex--;
                        updatePosition();
                    }
                });
            }

            desktopSwiper = {
                slides,
                isBeginning: activeIndex === 0,
                isEnd: activeIndex === slides.length - 1,
                update: updatePosition,
            };
        };

        const mobileSlider = () => {
            if (mobileSwiper) mobileSwiper.destroy(true, true);

            mobileSwiper = new Swiper(slider, {
                modules: [Navigation, Pagination],
                slidesPerView: 'auto',
                spaceBetween: 10,
                centeredSlides: true,
                navigation: { nextEl: btnNext, prevEl: btnPrev },
                pagination: {
                    el: '.team__pagination',
                    clickable: true,
                    bulletClass: 'team__pagination-bullet',
                    bulletActiveClass: 'team__pagination-bullet-active',
                },
                on: { slideChange: updateButtons }
            });
        };

        const handleResize = () => {
            const nowDesktop = window.innerWidth > 768;
            if (nowDesktop !== isDesktop) {
                isDesktop = nowDesktop;

                desktopSwiper = null;

                if (mobileSwiper) { 
                    mobileSwiper.destroy(true, true); 
                    mobileSwiper = null; 
                }

                if (isDesktop) desktopSlider();
                else mobileSlider();
            }

            if (desktopSwiper) desktopSwiper.update();
            if (mobileSwiper) mobileSwiper.update();
        };


        if (isDesktop) desktopSlider();
        else mobileSlider();

        window.addEventListener('resize', handleResize);
    }
}
